// @flow

import { connect } from 'react-redux';
import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import {
  fetchInfos as fetchInfo,
  selectCurrency,
  selectPrepaidAmount,
  selectIsFetchingInfos,
  selectIsLoadedInfos,
  selectCanChangeCurrency,
} from '@gandi/billing';
import { selectHasOwnerOnly } from '@gandi/cart';
import {
  selectOneOrganization,
  selectIsLoadedOneOrganization,
  selectIsFetchingOneOrganization,
  fetchOneOrganization,
} from '@gandi/redux-organization';
import { selectCurrentId, selectPersonalId } from '@gandi/redux-sharing';

import { withTranslator } from '@gandi/translate';

import { actions, formValueSelector } from 'gandi.react-form';
import { withLogger } from 'gandi.redux-logger';

import { setPatchContactsFlag } from 'src/Cart/DomainContacts/Wizard/modules/actions';
import { withRouter } from 'src/helpers/withRouter';
import { selectShopCurrent } from 'src/modules/organization/selectors';
import type { FullState, MapDispatchToProps } from 'src/types';

import AccountForm from '../components/Form/AccountForm';
import {
  patchOrganizationAndPrepaid,
  selectCurrencies,
} from '../modules/accounts';

import Presenter, {
  type DispatchProps,
  type InjectedProps,
  type StateProps,
} from './components/Presenter';

const selectField = formValueSelector(AccountForm.FORM_ID);

const mapStateToProps = (
  state: FullState,
  props: InjectedProps,
): StateProps => {
  const currentId = selectCurrentId(state);
  const orgId = ['myself', 'organization'].includes(props.params.orgId)
    ? currentId
    : props.params.orgId;

  const loadedOrg = selectIsLoadedOneOrganization(state, orgId);
  const fetchingOrg = selectIsFetchingOneOrganization(state, orgId);
  const org =
    currentId === orgId
      ? selectShopCurrent(state, false)
      : selectOneOrganization(state, orgId);
  const country = org?.country || selectField(state, 'country');
  const bu = org?.bu_id;
  // $FlowFixMe[incompatible-call]
  const canChangeCurrency = !!selectCanChangeCurrency(state, {
    sharingId: orgId,
  });
  // $FlowFixMe[incompatible-call]
  const currency = selectCurrency(state, { sharingId: orgId });
  const currencies = selectCurrencies(state, {
    // $FlowFixMe[incompatible-call]
    country,
    bu,
    currency,
    canChangeCurrency,
  });

  return {
    bu,
    orgId,
    currencies,
    loadedOrg,
    fetchingOrg,
    // $FlowFixMe[prop-missing] compat redux-sharing vs redux-orga
    org,
    // $FlowFixMe[incompatible-call]
    currency: selectCurrency(state, {
      sharingId: orgId,
    }),
    // $FlowFixMe[incompatible-call]
    prepaidAmount: selectPrepaidAmount(state, {
      sharingId: orgId,
    }),
    hasOwnerOnly: selectHasOwnerOnly(state),
    myself: org ? selectPersonalId(state) === orgId : false,
    // $FlowFixMe[incompatible-call]
    fetchingInfo: selectIsFetchingInfos(state, { sharingId: orgId }),
    // $FlowFixMe[incompatible-call]
    loadedInfo: selectIsLoadedInfos(state, { sharingId: orgId }),
  };
};

const mapActionsToProps: MapDispatchToProps<DispatchProps> = {
  fetchOneOrganization,
  patchOrganizationAndPrepaid,
  setPatchContactsFlag,
  fetchInfo,
  destroyForm: actions.destroy.bind(null, AccountForm.FORM_ID),
};

export default (compose(
  withTranslator({ propsNamespace: 'translator' }),
  withPageMeta(args => ({
    title: args.__('Edit account or organization information - Gandi.net'),
  })),
  withRouter,
  withLogger('Cart/Configure/Account/Edit'),
  connect(mapStateToProps, mapActionsToProps),
)(Presenter): React.ComponentType<{}>);
